import React from 'react';

import { Box, type ButtonProps, Link, Text } from '@opendoor/bricks-next';

export interface IAccountFormSubHeaderProps {
  isNewHuman: boolean;
  email?: string;
  hasSubmittedEmail: boolean;
  onValidEmailReset: ButtonProps['onPress'];
  loginSubHeaderText?: string;
  registrationSubHeaderText?: string;
  hidePasswordField?: boolean;
  phoneNumberInputHidden?: boolean;
}

const AccountFormSubHeader: React.FC<IAccountFormSubHeaderProps> = ({
  loginSubHeaderText,
  registrationSubHeaderText,
  email,
  onValidEmailReset,
  hasSubmittedEmail,
  isNewHuman,
  hidePasswordField,
  phoneNumberInputHidden,
}) => {
  const actionText = isNewHuman ? 'Signing up' : 'Signing in';
  const subHeaderText = isNewHuman ? registrationSubHeaderText : loginSubHeaderText;

  return (
    <Box>
      {subHeaderText && (
        <Text typography="$subheaderSmall" marginTop="$5x" marginBottom="$5x" tag="h2">
          {subHeaderText}
        </Text>
      )}
      {hasSubmittedEmail && !hidePasswordField && !phoneNumberInputHidden && (
        <Text typography="$bodySmall" tag="p" gap="$2x">
          {actionText} as{' '}
          <Link
            href="#"
            size="small"
            variant="secondary"
            analyticsName="Reset email"
            onPress={onValidEmailReset}
          >
            {email}
          </Link>
        </Text>
      )}
    </Box>
  );
};

export default AccountFormSubHeader;
